<template>
    <div id="nav-menu">
        <div id="nav-menu-container">
            <button class="button flat-button"
                    id="btn-close-nav"
                    @click="dismissHandle">
                &times;
            </button>
            <div class="nav-menu-card"
                 v-for="(item, index) in truncatedData"
                 :key="index">
                <router-link class="card-link button"
                             :to="`/catalog/${item.index}`"
                             @click.native="dismissHandle">
                    <image-view v-if="item.image"
                                type="background"
                                class="img raster"
                                size="medium"
                                :url="item.image"/>
                    <img v-else
                         class="svg"
                         :src="require(`@/assets/${item.icon}-24px.svg`)"
                         :alt="item.title"/>
                </router-link>
                <div class="card-body">
                    <span class="card-title">{{item.title}}</span>
                    <ListView class="card-list"
                              type="flat"
                              :data="item.items"
                              :callback="dismissHandle"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import ListView from "@/components/ListView";
	import ImageView from "@/components/ImageView";

	export default {
		name: "NavigationMenu",
		components: {ImageView, ListView},
		props: {
			data: {
				type: Array,
				required: true
			},
			dismissHandle: {
				type: Function,
				required: true
			}
		},
		data() {
			return {
				maxItems: 3
			};
		},
		computed: {
			truncatedData() {
				let returnData = JSON.parse(JSON.stringify(this.data));
				for (let item of returnData) {
					if (item.items.length > this.maxItems) {
						item.items.splice(this.maxItems, item.items.length - this.maxItems);
						item.items.push({name: this.$lang.navMore, link: `/catalog/${item.index}`});
					}
				}
				return returnData;
			}
		}
	}
</script>

<style scoped lang="scss">
    #nav-menu {
        position: relative;
        width: 100%;
        z-index: 1;
        top: -64px;
        padding-top: 64px;
        left: 0;
        padding-bottom: 16px;
        border-bottom: $dotted;
        background-color: $p-bg;
    }

    #nav-menu-container {
        display: grid;
        position: relative;
        margin: 0 auto;
        width: 100%;
        max-width: 1200px;
        grid-template-columns: repeat(3, calc(33.33% - 21.33px));
        column-gap: 16px;
        row-gap: 8px;
        box-sizing: border-box;
        padding: 16px 24px 4px 24px;
        border-radius: 24px;
        transform: translateZ(0);
    }

    button {
        background-color: transparent;
    }

    #btn-close-nav {
        position: absolute;
        right: 16px;
        top: 16px;
        line-height: 20px;
        font-size: 32px;
        padding: 0;
    }

    .nav-menu-card {
        position: relative;
        display: flex;
        flex-flow: row nowrap;
        height: 192px;
        overflow-y: visible;
        background-color: $p-bg;
        align-items: center;
    }

    .nav-menu-card::after {
        position: absolute;
        content: " ";
        right: 8px;
        bottom: 8px;
        height: 8px;
        width: 8px;
        clip-path: polygon(100% 0%, 100% 100%, 0% 100%);
        background-color: $p-fg;
    }

    .card-link {
        position: relative;
        height: 90%;
        min-width: 100px;
        max-width: 100px;
        padding: 0;
    }

    .card-body {
        display: flex;
        flex-flow: column nowrap;
        flex-grow: 1;
        margin-left: 16px;
        margin-top: 8px;
    }

    img, .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .img.raster:hover {
        filter: brightness(0.4);
    }

    .card-title {
        position: relative;
        height: 16px;
        margin: 0 12px;
        font-size: 17px;
        line-height: 16px;
        font-family: $serif;
        font-weight: 700;
        padding-bottom: 8px;
        border-bottom: $dotted;
    }

    .card-list::v-deep .list-item {
        text-align: left;
        line-height: 24px;
    }

    .card-list {
        height: 140px;
        overflow-y: hidden;
    }

    @include gridFallback {
        .nav-menu-card {
            display: inline-flex;
            width: calc(33.33% - 16px);
            margin-right: 16px;
        }
    }

</style>